import { Navigate } from 'react-router-dom'
import { useAuth } from '../../context/AuthContext'

function VerifyEmailRoute({ children }) {
  const { isAuthenticated, emailVerified, loading } = useAuth()

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="flex flex-col items-center gap-4">
          <div className="w-12 h-12 border-4 border-primary-200 border-t-primary-600 rounded-full animate-spin" />
          <p className="text-gray-500">Loading...</p>
        </div>
      </div>
    )
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />
  }

  if (emailVerified) {
    return <Navigate to="/dashboard" replace />
  }

  return children
}

export default VerifyEmailRoute
